import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import DashboardOwnerCards from "./DashboardOwnerCards";
import DashboardOwnerInfoCards from "./DashboardOwnerInfoCards";
import LineChart from "../../LineChart/UI/LineChart";
import MapLocation from "./DashboardOwnerMap";
import { getDashboardOwnerData } from "../Application/DashboardOwner.business";
import { getOwnersSelector } from "../Infrastructure/DashboardOwner.reducer";
import {
  getSelectedProjectSelector,
  getsetOwnersByProjectSelector,
} from "../../Owners/Infrastructure/Owners.reducer";
import "./DashboardOwner.css";
import {
  getOwnersByProject,
  getSelectedProject,
} from "../../Owners/Application/Owners.bussines";
import { saveSelectedProject } from "../../Owners/Infrastructure/Owners.store";

const DashboardOwner = () => {
  const ownerData = useSelector(getOwnersSelector);
  const [cards, setCards] = useState({});
  const [year, setYear] = useState("");
  const [loading, setLoading] = useState(true);
  const selectedProject = useSelector(getSelectedProjectSelector);
  const ownersByProject = useSelector(getsetOwnersByProjectSelector);
  const fetchDashboardData = async () => {
    setLoading(true);
    try {
      if (selectedProject != null) {
        await getDashboardOwnerData(selectedProject);
      }
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const ensureDefaultProject = async () => {
      try {
        if (!Array.isArray(ownersByProject) || ownersByProject.length === 0) {
          await getOwnersByProject();
          return;
        }

        if (!selectedProject) {
          const firstProject = ownersByProject[0];
          await getSelectedProject(firstProject.id);
          saveSelectedProject(firstProject.id);
        }
      } catch (error) {
        console.error("Error ensuring default project:", error);
      }
    };

    ensureDefaultProject();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ownersByProject, selectedProject]);

  useEffect(() => {
    fetchDashboardData().finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (selectedProject !== null) {
      fetchDashboardData();
    }
  }, [selectedProject]);

  useEffect(() => {
    if (ownerData && Object.keys(ownerData).length > 0) {
      const { total_per_unit = 0, total_removal = 0, info } = ownerData;
      const { removalavoidance = "" } = info ?? {};
      const type = ownerData?.info?.project_type ?? "";

      setCards({
        total_per_unit,
        total_removal,
        removalavoidance,
        type,
      });
    } else {
      setCards({});
    }
  }, [ownerData]);

  const transformRemovalToEmissionData = () => {
    if (!ownerData?.removal_per_month) return { emission_per_month: [] };

    const removalData = ownerData.removal_per_month;
    const emissionPerMonth = [];

    // Convertir el objeto en array para el LineChart
    Object.keys(removalData).forEach((dateKey) => {
      const [month, day, year] = dateKey.split("/").map(Number);

      emissionPerMonth.push({
        date: `${year}-${month.toString().padStart(2, "0")}-${day
          .toString()
          .padStart(2, "0")}`,
        tons: removalData[dateKey],
      });
    });

    return {
      emission_per_month: emissionPerMonth,
      year: new Date().getFullYear(),
    };
  };

  const lineChartData = transformRemovalToEmissionData();

  const certifier = ownerData?.info?.certifier ?? null;
  const methodology = ownerData?.info?.methodology ?? null;
  const registry = ownerData?.info?.registry ?? null;
  const urlRegistry = ownerData?.info?.url_registry ?? null;

  console.log(ownerData);
  const projectName =
    ownersByProject.find((p) => p.id === selectedProject)?.project_name || null;

  return (
    <div style={{ position: "relative", minHeight: "100vh", maxWidth: "95vw" }}>
      <div className="title">{projectName || ""}</div>
      <DashboardOwnerCards cards={cards} year={year} isLoading={loading} />
      <div className="grid-container" style={{ padding: "23px" }}>
        <div className="grid-item">
          <LineChart lineData={lineChartData} isLoading={loading} />
        </div>
        <div>
          <MapLocation
            latitude={ownerData?.latitude}
            longitude={ownerData?.longitude}
            isLoading={loading}
          />
        </div>
      </div>
      <DashboardOwnerInfoCards
        certifier={certifier}
        methodology={methodology}
        registry={registry}
        urlRegistry={urlRegistry}
        isLoading={loading}
      />
    </div>
  );
};

export default DashboardOwner;
